module.exports = __webpack_public_path__ + "static/okLogoMenu-4192f3b77e38535ad2f62aa962f71934.svg";